export default __webpack_public_path__ + "images/arrow.35e37c1e793c7387081e66f4767e860e.svg";